import { NgModule } from '@angular/core';
import { AppStoreModule } from '@fund-base/store/store.module';
import { AppComponent } from '@fund-base/app/app.component';
import { AppRoutingModule } from '@fund-base/app/app-routing.module';
import { AppSharedModule } from '@fund-base/shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BackButtonDirective } from '@fund-base/app/back-button.directive';
import { NavigationService } from '@fund-base/app/navigation.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TokenInterceptor } from '@fund-base/shared/interceptors/token.interceptor';
import { OAuthModule } from 'angular-oauth2-oidc';
import { LanguageInterceptor } from '@fund-base/shared/interceptors/language.interceptor';
import { NgxStripeModule } from 'ngx-stripe';
import { environment } from '@fund-base/environments/environment';
import { HtmlService } from '@fund-base/app/htmlService.service';
import { MatDialogModule } from '@angular/material/dialog';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { APP_INITIALIZER } from '@angular/core';
import { Store } from '@ngrx/store';
import { StorageService } from '@fund-base/services/storage/storage.service';
import { setToken, setUser, setVisitor } from '@fund-base/store/actions/auth.actions';
import { authTokenLocalStorageKey, authUserLocalStorageKey } from '@fund-base/constants/auth/auth.constants';
import { User } from '@fund-base/types/auth/auth.types';
import { AiChatWidgetComponent } from '@fund-base/components/ai-chat-widget/ai-chat-widget.component';
import { AtlasAiLogoComponent } from '@fund-base/components/atlas-ai-logo/atlas-ai-logo.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

function initializeAuth(store: Store, storageService: StorageService) {
  return () => {
    const token: string | undefined = storageService.getItem(authTokenLocalStorageKey);
    const user: User | undefined = storageService.getItem(authUserLocalStorageKey);

    if (token) {
      store.dispatch(setToken({ token }));
    }

    if (user) {
      // Determine if it's a user or visitor based on organization property
      if (user.organization) {
        store.dispatch(setUser({ user }));
      } else {
        store.dispatch(setVisitor({ visitor: user }));
      }
    }
  };
}

@NgModule({
  declarations: [AppComponent, BackButtonDirective, AiChatWidgetComponent, AtlasAiLogoComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    AppRoutingModule,
    AppSharedModule,
    AppStoreModule,
    HttpClientModule,
    CKEditorModule,
    MatTableModule,
    MatCheckboxModule,
    NgxStripeModule.forRoot(environment?.stripePublishableKey),
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [''],
        sendAccessToken: true,
      },
    }),
  ],
  bootstrap: [AppComponent],
  providers: [
    NavigationService,
    HtmlService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [Store, StorageService],
      multi: true
    }
  ],
})
export class AppModule {}
